<script setup lang="ts">
/**
 * Toutes les adhésions d'une association — page publique « tout lister », partageable telle quelle.
 * Voir `AssoListeFeature` pour le pourquoi.
 */
const slug = (useRoute().params as { slug: string }).slug;
const { t } = useI18n();
</script>

<template>
  <AssoListeFeature
    :slug="slug"
    domaine="membership-plans"
    :titre="t('association.listeAdhesions.titre')"
    :sous-titre="t('association.listeAdhesions.sousTitre')"
    :message-vide="t('association.listeAdhesions.messageVide')"
  />
</template>
